<full-modal-config
    modalTitle="{{ l10nKeys.modalTitle | vtranslate }}"
    [modified]="true"
    (onCancel)="handleCancel()"
    (onSubmit)="handleSubmit()"
    [busy]="busy"
    [errors]="error"
    [valid]="isFormValid"
    class="proxy-config-modal"
>
    <form
        clrForm
        [clrLayout]="verticalLayout"
        *ngIf="portalInfoItem?.config?.split_proxy_configuration"
    >
        <full-modal-tab-section tabTitle="{{ l10nKeys.proxyLabel | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.proxyLabel | vtranslate }}</h3>
                <avi-proxy [editable]="portalInfoItem"></avi-proxy>
            </div>
        </full-modal-tab-section>
    </form>
</full-modal-config>
